import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  markVideoAsSeen,
  markPdfAsSeen,
  resetMediaSeen,
} from "../../store/patient/viewMediaSlice";
import { sleep } from "../../helpers";

export const useViewMediaStore = () => {
  const dispatch = useDispatch();

  const { hasSeenProcedureVideo, hasSeenProcedurePdf } = useSelector(
    (state) => state.patient.viewMedia
  );

  const startProcedureVideoSeen = useCallback(() => {
    dispatch(markVideoAsSeen());
  }, [dispatch]);

  const startProcedurePdfSeen = useCallback(async () => {
    await sleep(5000);
    dispatch(markPdfAsSeen());
  }, [dispatch]);

  const startResetMediaSeen = useCallback(() => {
    dispatch(resetMediaSeen());
  }, [dispatch]);

  return {
    // Props
    hasSeenProcedureVideo,
    hasSeenProcedurePdf,

    // Methods
    startProcedureVideoSeen,
    startProcedurePdfSeen,
    startResetMediaSeen,
  };
};
